import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

import { getListArticlesPmAction } from "../../../../../redux/action/projectAction";
import ButtonLink from "../../../../components/button/ButtonLink";

const FilterListArticles = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [filterValue, setFilterValue] = useState({
    category: "",
    type: "",
    order: "",
  });
  const { parsed } = props;

  const orderItems = [
    { name: "Terbaru", code: "desc" },
    { name: "Terlama", code: "asc" },
  ];

  const searchingHandler = useRef(
    _.debounce((search) => {
      const params = {
        q: search,
        orderField: parsed?.order || "",
        orderDir: parsed?.order === "createdAt" ? "desc" : "asc",
        page: 1,
        perpage: 10,
      };

      history.push(
        `/admin/pm/list-articles?search=${search}&order=${parsed?.order ||
          ""}&page=1`
      );
      dispatch(getListArticlesPmAction(params));
    }, 1000)
  ).current;

  const filterHandler = (data) => {
    setFilterValue(data);
    const params = {
      q: parsed?.search || "",
      category: data?.category || "",
      type: data?.type || "",
      orderField: "updatedAt",
      orderDir: data?.order,
      page: 1,
      perpage: 10,
    };

    history.push(
      `/admin/pm/list-articles?search=${parsed?.search ||
        ""}&order=${data.order || ""}&page=1`
    );
    dispatch(getListArticlesPmAction(params));
  };

  return (
    <div className="p-d-flex p-jc-between p-mb-3">
      <div className="filter">
        <div className="filter-field">
          <InputText
            id="search"
            aria-describedby="search-help"
            className="p-d-block search-inputtext"
            placeholder="Cari"
            onChange={(e) => searchingHandler(e.target.value)}
          />
          <p>
            Cari berdasarkan <span>Judul tulisan</span>
          </p>
        </div>
        <div className="filter-wrapp">
          <div className="sort-filter">
            <Dropdown
              value={filterValue.order}
              options={orderItems}
              onChange={(e) =>
                filterHandler({
                  ...filterValue,
                  order: e.target.value,
                })
              }
              optionLabel="name"
              optionValue="code"
              placeholder="Terbaru"
            />
            <small className="p-d-block">Urutkan Tulisan</small>
          </div>
        </div>
      </div>
      <ButtonLink label="Tambah Tulisan" link="/admin/pm/create-article" />
    </div>
  );
};

export default FilterListArticles;
